// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1pJjG","errorLogs":"EditorFooter_errorLogs__2QhKA"};